import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-info-modal',
  imports: [TranslatePipe],
  templateUrl: './info-modal.component.html',
  styleUrl: './info-modal.component.scss',
})
export class InfoModalComponent {
  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<InfoModalComponent>,
    @Inject(DIALOG_DATA)
    public data: {
      title: string;
      content: string;
      actionOnConfirm: boolean;
    }
  ) {}

  public close(): void {
    this.dialogRef.close();
  }

  public confirm(): void {
    this.dialogRef.close(true);
  }
}
